// @flow
import * as React from 'react';
import {
    Pressable, StyleSheet, useWindowDimensions, View,
} from 'react-native';
import { Header, Icon } from 'react-native-elements';
import { PRIMARY_COLOR, RED_COLOR } from 'coooltv-js-shared/src/styles/common';
import Text from './CustomText/CustomText';
import { GREY_COLOR } from '../styles/common';

const styles = StyleSheet.create({
    text: {
        fontWeight: 100,
        color: GREY_COLOR,
        borderBottomWidth: 2,
        borderRightStyle: 'solid',
        borderColor: PRIMARY_COLOR,
        alignSelf: 'flex',
        width: 'fit-content',
        padding: 20,
    },
    fontSizeWeb: {
        fontSize: 33,
    },
    fontSizeMobile: {
        fontSize: 18,
    },
    header: {
        paddingHorizontal: 0,
        paddingVertical: 0,
        marginLeft: 20,
    },
    left_container: {
        flexBasis: 'auto',
    },
    container_wrapper: {
        flexDirection: 'row',
    },
    icon: {
        alignSelf: 'end',
    },
});

type Props = {
    text: String,
    onDeleteHandler?: Function,
};

const Title = (props: Props) => {
    const { text, onDeleteHandler } = props;
    const { width } = useWindowDimensions();
    return (
        <Header leftContainerStyle={styles.left_container} containerStyle={styles.header} backgroundColor="white">
            <View style={styles.container_wrapper}>
                <Text style={width > 600 ? [styles.text, styles.fontSizeWeb] : [styles.text, styles.fontSizeMobile]}>
                    {text}
                </Text>
                {onDeleteHandler && (
                    <Pressable onPress={onDeleteHandler} style={styles.icon}>
                        <Icon
                            type="material"
                            name="delete-forever"
                            color={RED_COLOR}
                            size={30}
                        />
                    </Pressable>
                )}
            </View>
        </Header>
    );
};

Title.defaultProps = {
    onDeleteHandler: undefined,
};

export default Title;
